(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Tracking = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target, varArgs) {
      // .length of function is 2
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector;

window.JPtrackingInit = false;

var analyticsDefault = function analyticsDefault() {
  return {
    platform: window.PLATFORM
  };
};

var analyticsServiceEvents = ['action:general:converted-to-parking'];

window.analyticsTrack = function (segment, options) {
  if (analyticsServiceEvents.indexOf(segment) !== -1) {
    var user = options.user;
    delete options.user;
    trackEvent(segment, user, options);
  }

  analytics.track(segment, Object.assign({}, analyticsDefault(), options));
};

window.analyticsPage = function (page, options) {
  analytics.page(page, Object.assign({}, analyticsDefault(), options));
};

var trackEvent = function trackEvent(name, user, data) {
  var payload = {
    name: name,
    type: 'track',
    properties: data
  };

  if (user && user.id) {
    payload.userId = user.id.toString();
  }

  if (user && user.anonymousId) {
    payload.anonymousId = user.anonymousId;
  }

  Tracking.sendEvent(payload);
};

var Tracking = {
  init: function init() {
    if (window.JPtrackingInit) {
      return;
    }
    this.addListeners();
    window.JPtrackingInit = true;
  },

  track: function track(target, prefix, event) {
    var expectedEvent = target.getAttribute(prefix + 'track-event');

    if (expectedEvent && expectedEvent !== event.type) {
      return;
    }

    var options = {
      element: target.id,
      option: target.getAttribute(prefix + 'track-options'),
      platform: window.PLATFORM
    };

    if (target.hasAttribute(prefix + 'track-poe')) {
      options.pay_on_arrival = target.getAttribute(prefix + 'track-poe');
    }

    analytics.track(target.getAttribute(prefix + 'track'), options);
  },

  sendEvent: function sendEvent(data) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', "https://analytics.justpark.com" + '/events', true);
    xhr.setRequestHeader('Content-type', 'application/json');
    xhr.send(JSON.stringify(data));
  },

  addListeners: function addListeners() {
    var track = this.track;

    var handler = function handler(target) {
      track(target, '', event);
    };

    var reactHandler = function reactHandler(target, event) {
      track(target, 'data-', event);
    };

    var changeHandler = function changeHandler(event) {
      var target = event.target || event.srcElement;

      if (target.matches('select[track]') || target.matches('input[track], a[track], button[track], span[track]')) {
        handler(target, event);
      }

      if (target.matches('input[data-track], a[data-track], button[data-track], span[data-track]')) {
        reactHandler(target, event);
      }
    };

    document.addEventListener('DOMContentLoaded', function () {
      document.body.addEventListener('change', changeHandler);
      document.body.addEventListener('click', changeHandler);
    }, false);
  }
};

Tracking.init();

module.exports = Tracking;

},{}]},{},[1])(1)
});